import { EyeOutlined } from '@ant-design/icons';
import { Button, Modal, Space, Tabs, Image, Alert } from 'antd';
import { Storage } from 'aws-amplify';
import React, { useState } from 'react';
import backofficeService from '../../../../services/backofficeService';

export default function BotonVerArchivos({
  record,
  keyId,
  tipo,
  visible,
  setVisible,
}) {
  const [data, setData] = useState([]);
  const [activeTab, setActiveTab] = useState('1');
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('sessionToken');

  const handleCancel = () => {
    setVisible(false);
    setData([]);
  };

  const handleVisible = () => {
    if (tipo === 'Contratos') {
      setLoading(true);
      getContratos(record);
    } else if (tipo === 'Anexos') {
      setLoading(true);
      getAnexos(record);
    } else {
      setLoading(true);
      getDocumentos(record);
    }
  };

  const getContratos = async (element) => {
    const pathContratos = Object.keys(element.pathContratos);
    const arrayContratos = [];
    pathContratos.forEach((path) => {
      const array = element.pathContratos[path];
      arrayContratos.push(array);
    });
    arrayContratos.forEach(async (array) => {
      await Storage.get(array, { download: true }).then((fileData) => {
        let blob = fileData;
        if (!(fileData instanceof Blob)) {
          try {
            blob = new Blob([fileData.Body], { type: 'application/pdf' });
          } catch (error) {
            console.error('Error al convertir los datos en un Blob:', error);
            return;
          }
        }
        const nombre = array.split('/')[4].split('#')[0];
        setData((data) => [
          ...data,
          { name: nombre, url: URL.createObjectURL(blob), tipo: 'pdf' },
        ]);
        setLoading(false);
        setVisible(true);
      });
    });
  };

  const getAnexos = async (element) => {
    const arrayAnexos = Object.values(element.pathAnexos);
    arrayAnexos.forEach(async (array) => {
      await Storage.get(array, { download: true }).then((fileData) => {
        let blob = fileData;
        if (!(fileData instanceof Blob)) {
          try {
            blob = new Blob([fileData.Body], { type: 'application/pdf' });
          } catch (error) {
            console.error('Error al convertir los datos en un Blob:', error);
            return;
          }
        }
        const nombre = array.split('/')[5].split('-').join(' ').split('.')[0];
        setData((data) => [
          ...data,
          { name: nombre, url: URL.createObjectURL(blob), tipo: 'pdf' },
        ]);
        setLoading(false);
        setVisible(true);
      });
    });
  };

  const getDocumentos = async (element) => {
    const response = await backofficeService.consultarTrabajador(
      token,
      element.empresaId,
      element.correo,
      25,
      ''
    );
    const data = response[0].data.registro[0].documentos;
    data.forEach((element) => {
      const fileUrl = element.url;
      fetch(fileUrl)
        .then((res) => res.blob())
        .then((blob) => {
          try {
            const nombre = element.tipo;
            const tipo = blob.type.split('/')[0] === 'image' ? 'imagen' : 'pdf';
            const blobNamed = new Blob([blob], { type: blob.type });
            setData((data) => [
              ...data,
              {
                name: nombre,
                url: URL.createObjectURL(blobNamed),
                tipo,
              },
            ]);
          } catch (error) {
            console.error('Error al convertir los datos en un Blob:', error);
            return;
          }
        });
    });
    setLoading(false);
    setVisible(true);
  };

  const handleChangeTab = (key) => {
    setActiveTab(key);
  };

  return (
    <Space key={keyId}>
      {tipo === 'Contratos' && (
        <Space key={keyId}>
          <Modal
            title="Contratos"
            open={visible}
            onOk={handleCancel}
            onCancel={handleCancel}
            width={1250}
            footer={[
              <Button key="back" onClick={handleCancel}>
                Cerrar
              </Button>,
            ]}>
            <Tabs
              activeKey={activeTab}
              onChange={handleChangeTab}
              type="card"
              size="small">
              {data
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((document, index) => (
                  <Tabs.TabPane
                    key={index + 1}
                    tab={document.name.split('_').join(' ')}>
                    {document.tipo === 'imagen' ? (
                      <Image
                        alt="Contrato"
                        src={document.url}
                        title={`Contrato ${document.name}`}
                        preview={{
                          bodyStyle: {
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          },
                        }}
                      />
                    ) : (
                      <iframe
                        src={document.url}
                        width="100%"
                        height="600px"
                        title={`Contrato ${document.name}`}></iframe>
                    )}
                  </Tabs.TabPane>
                ))}
            </Tabs>
          </Modal>
          <Button
            size="small"
            type="text"
            onClick={handleVisible}
            loading={loading}>
            <EyeOutlined />
            Ver Contratos
          </Button>
        </Space>
      )}
      {tipo === 'Anexos' && (
        <Space key={keyId}>
          <Modal
            title="Anexos"
            open={visible}
            onOk={handleCancel}
            onCancel={handleCancel}
            width={1250}
            footer={[
              <Button key="back" onClick={handleCancel}>
                Cerrar
              </Button>,
            ]}>
            <Tabs
              activeKey={activeTab}
              onChange={handleChangeTab}
              type="card"
              size="small">
              {data
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((document, index) => (
                  <Tabs.TabPane
                    key={index + 1}
                    tab={document.name.split('_').join(' ')}>
                    {document.tipo === 'imagen' ? (
                      <Image
                        alt="Anexo"
                        src={document.url}
                        title={`Anexo ${document.name}`}
                        preview={{
                          bodyStyle: {
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          },
                        }}
                      />
                    ) : (
                      <iframe
                        src={document.url}
                        width="100%"
                        height="600px"
                        title={`Contrato ${document.name}`}></iframe>
                    )}
                  </Tabs.TabPane>
                ))}
            </Tabs>
          </Modal>
          <Button
            size="small"
            type="text"
            onClick={handleVisible}
            loading={loading}>
            <EyeOutlined />
            Ver Anexos
          </Button>
        </Space>
      )}
      {tipo === 'Documentos' && (
        <Space key={keyId}>
          <Modal
            title="Documentos"
            style={{ zIndex: 9999 }}
            open={visible}
            onOk={handleCancel}
            onCancel={handleCancel}
            width={1250}
            footer={[
              <Button key="back" onClick={handleCancel}>
                Cerrar
              </Button>,
            ]}>
            <Tabs
              activeKey={activeTab}
              onChange={handleChangeTab}
              type="card"
              size="small">
              {data
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((document, index) => (
                  <Tabs.TabPane key={index + 1} tab={document.name}>
                    {document.tipo === 'imagen' ? (
                      <>
                        <Alert
                          message="Para agrandar o rotar la imagen, puede hacer click en ella y utilizar los botones que le aparecerán en la parte superior derecha"
                          type="info"
                        />
                        <br />
                        <Image
                          alt="Documento"
                          src={document.url}
                          title={`Documento ${document.name}`}
                          preview={{
                            bodyStyle: {
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            },
                          }}
                        />
                      </>
                    ) : (
                      <iframe
                        src={document.url}
                        width="100%"
                        height="600px"
                        title={`Documento ${document.name}`}></iframe>
                    )}
                  </Tabs.TabPane>
                ))}
            </Tabs>
          </Modal>
          <Button
            size="small"
            type="text"
            onClick={handleVisible}
            loading={loading}>
            <EyeOutlined />
            Ver Documentos
          </Button>
        </Space>
      )}
    </Space>
  );
}
